import { useEffect } from 'react';
import { useParams, Outlet, Navigate } from 'react-router-dom';
import { useViewMode } from '@/lib/view-mode-context';
import AppShell from './AppShell';

export default function PublicRouteHandler() {
  const { userId } = useParams<{ userId: string }>();
  const { setPublicUser } = useViewMode();

  useEffect(() => {
    if (userId) {
      setPublicUser(userId);
    }
    return () => setPublicUser(null);
  }, [userId, setPublicUser]);

  if (!userId) {
    return <Navigate to="/" replace />;
  }

  return <AppShell />;
}
